import { createSlice } from '@reduxjs/toolkit';
import { actions as authActions } from './authSlice';

const initialState = {
  isLoaded: false,
  customer: {
    companyName: '',
    vatId: '',
    custom: {
      fields: {
        cocNumber: '',
        isCompany: '',
        isApiUser: false,
        collectiveInvoiceInterval: '',
      },
    },
  },
  account: {
    id: '',
    firstName: '',
    lastName: '',
    email: '',
    newsletterOptIn: '',
  },
  surveyDetails: [],
};

const mapCustomerDataToState = (data) => {
  const {
    addresses,
    ...customer
  } = data;

  return customer;
};

const mapAccountPayloadToState = ({ state, payload }) => ({
  id: payload.id || state.account.id,
  firstName: payload.firstName || state.account.firstName,
  lastName: payload.lastName || state.account.lastName,
  email: payload.email || state.account.email,
  newsletterOptIn: payload.newsletterOptIn || state.account.newsletterOptIn,
});

const handleGetAccountSuccess = (state, { payload }) => {
  // This method is run multiple time as people log in/browse the site.
  // Depending on how and where this method is triggered, it may not have the customer and surveyDetail data.
  const { account, customer } = payload;
  state.account = mapAccountPayloadToState({
    state,
    payload: account,
  });

  if (account.surveyDetails) {
    state.surveyDetails = account.surveyDetails;
  }

  if (customer) {
    state.customer.companyName = customer.companyName;
    state.customer.vatId = customer.vatId;
    state.customer.custom.fields.cocNumber = customer.cocNumber;
    state.customer.custom.fields.isCompany = customer.isCompany;
    state.customer.custom.fields.isApiUser = customer.isApiUser;
  }
};

/**
 * Customer slice
 */
export const { reducer, actions } = createSlice({
  name: 'customer',
  initialState,
  reducers: {
    getAccount: () => { },
    getAccountRequest: () => { },
    getAccountSuccess: handleGetAccountSuccess,
    getAccountFailure: () => { },
    updateAccount: () => { },
    updateAccountRequest: () => { },
    updateAccountSuccess: handleGetAccountSuccess,
    updateAccountFailure: () => { },
    getCustomer: () => { },
    getCustomerRequest: () => { },
    getCustomerSuccess: (state, { payload }) => {
      state.isLoaded = true;
      state.customer = mapCustomerDataToState(payload.customer);
    },
    getCustomerFailure: () => { },
    updateSurveyDetails: () => { },
    updateSurveyDetailsSuccess: (state, { payload }) => {
      state.surveyDetails = payload.surveyDetails;
    },
  },
  extraReducers: {
    [authActions.logoutRequest]: () => initialState,
    [authActions.loginSuccess]: handleGetAccountSuccess,
  },
});

/**
 * Selectors
 */

export const selectors = {
  getCustomerId: ({ customer }) => customer?.data?.id || null,
  getCustomerGroupId: ({ customer }) => customer?.customer?.customerGroup?.id || null,
  getCustomerData: ({ customer }) => customer.customer,
  getCustomerFirstName: ({ customer }) => customer.account.firstName || '',
  getCustomerLastName: ({ customer }) => customer.account.lastName || '',
  getCustomerEmail: ({ customer }) => customer.customer.email || '',
  getAccountId: ({ customer }) => customer.account.id || '',
  getSurveyDetails: ({ customer }) => customer.surveyDetails || [],
  isNewsletterOptIn: ({ customer }) => customer.account.newsletterOptIn || '',
  isCustomerLoaded: ({ customer }) => customer.isLoaded,
  isAccountLoaded: ({ customer }) => customer.account.id?.length > 0 || false,
  isCustomerCompany: ({ customer }) => customer.customer?.custom?.fields?.isCompany || false,
  isApiUser: ({ customer }) => customer.customer?.custom?.fields?.isApiUser || false,
};
